import { createAction } from '@reduxjs/toolkit';

export const resetStoreAction = createAction('store/reset');
